<template>
  <div class="MissionArchive">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row class="mt-2">
          <v-col cols="12" sm="6">
            <v-row>
              <v-col class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("fromDate") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker
                  :label="$t('fromDate') + ':'"
                  :initDate="initBeginDate"
                  @dateResult="bDate"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="mt-2 mt-sm-0">
              <v-col class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("toDate") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker
                  :label="$t('toDate') + ':'"
                  :initDate="initEndDate"
                  @dateResult="eDate"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row class="mt-2">
              <v-col class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("requestType") }} : </label>
              </v-col>
              <v-col>
                <v-select
                  hide-details
                  v-model="missionRequestType"
                  :items="missionRequestTypes"
                  :label="$t('requestType')"
                  item-text="Name"
                  item-value="Code"
                  return-object
                  dense
                  solo
                  v-on:change="changeMissionType"
                  class="my-auto py-0"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>

          <v-btn
            class="px-5"
            color="primary"
            :loading="isLoading"
            @click="search"
            >{{ $t("search") }}</v-btn
          >
        </v-card-actions>
      </div>
    </box>

    <box class="mt-2" :title="$t('missionList')">
      <div class="vacationList">
        <div v-if="list.length > 0">
          <person-mission-list-web
            :pagination="true"
            @onClickMission="onClickMission"
            :list="list"
            class="hidden-sm-and-down"
          />
          <person-mission-list-mob
            @onClickMission="onClickMission"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <EmptyList />
        </div>
      </div>
    </box>

    <mission-archive-details
      class="mt-2"
      ref="MissionArchiveDetails"
      @refresh="search"
    />
  </div>
</template>

<script>
import PersonMissionListMob from "../../components/functionality/periodDetails/PersonMissionList/PersonMissionListMob.vue";
import PersonMissionListWeb from "../../components/functionality/periodDetails/PersonMissionList/PersonMissionListWeb.vue";
import MissionArchiveDetails from "../../components/request/MissionArchiveDetails.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import EosToastType from "../../model/EosToastType";
import type from "../../model/MissionRequestType";
import ResultType from "../../model/ResultType";
//import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    DialogDatePicker,
    PersonMissionListWeb,
    PersonMissionListMob,
    MissionArchiveDetails,
  },
  data() {
    return {
      missionRequestTypes: [],
      missionRequestType: "",
      isLoading: false,
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      list: [],
    };
  },
  mounted() {
    var moment = require("jalali-moment");
    var year = moment().locale("fa").format("YYYY");
    this.initBeginDate = year + "/01/01";

    this.initEndDate = moment().locale("fa").endOf("year").format("YYYY/MM/DD");

    this.missionRequestTypes = type.MissionRequestTypeArray();
    if (this.missionRequestTypes.length > 0) {
      this.missionRequestType = this.missionRequestTypes[0];
    }
  },
  methods: {
    bDate(date) {
      this.beginDate = date;
      this.search();
    },
    eDate(date) {
      this.endDate = date;
      this.search();
    },
    changeMissionType() {
      this.search();
    },
    search() {
      if (!this.beginDate || !this.endDate) {
        return;
      }
      this.hideDetails();

      const params = new URLSearchParams();
      params.append("beginDate", this.beginDate);
      params.append("endDate", this.endDate);
      params.append("searchKind", this.missionRequestType.Code);

      this.$store.dispatch("PersonMissionList", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data;
        } else {
          this.list = [];
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || "error",
          });
        }
      });
    },
    onClickMission(item) {
      this.hideDetails();
      this.$refs.MissionArchiveDetails.show(item);
      /*const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(item.Pageno));
      params.append("dbkind", item.DBKind);
      params.append("year", item.Year);

      this.$store
        .dispatch("GetMissionDetailForPerson", { params })
        .then((result) => {
          //console.log(result);
          if (result.type == "success") {
            if (result.data.length > 0) {
              let details = result.data[0];
              this.$refs.MissionArchiveDetails.show(item, details);
            }
          }
        });*/
    },
    hideDetails() {
      this.$refs.MissionArchiveDetails.hide();
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 100px;
}
</style>